export default __webpack_public_path__ + "static/media/create-inventory-group-icon.98b8ff67.svg";